import { render, staticRenderFns } from "./InfoSlider.vue?vue&type=template&id=d4be06b6&"
import script from "./InfoSlider.vue?vue&type=script&lang=js&"
export * from "./InfoSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports